'use strict';

export default {
	route: '/grape-ui/log-out',
	setup: async function() {
		await fetch('/api/session/logout');
		Grape.UsersPlugin.setSession(null);
		Grape.navigate('/');
	}
};

